import { Class } from 'src/interfaces/class.types';
import { ClassGrades, GRADES } from 'src/interfaces/grades.types';

const prepareGradesForDisplaying = (grades: ClassGrades[]): GRADES[] =>
  grades.map((grade) => grade.replace(/^0|g/i, '') as GRADES);

const generateLabel = (grades: ClassGrades[]) => {
  if (!grades.length || (grades as string[]).includes('Other')) return '';

  const preparedGrades = prepareGradesForDisplaying(grades);

  return `Grade ${preparedGrades.join(', ')}`;
};

export const generateClassPickerOption = (cl: Class) => ({
  value: cl.sourcedId,
  title: cl.displayName,
  label: generateLabel(cl.grades as ClassGrades[]),
});

export const sortClassesByGradesInDesc = (classes: Class[]) => {
  const validGrades = classes.filter((cl) => !cl.grades.includes('Other'));
  const otherGrades = classes.filter((cl) => cl.grades.includes('Other'));

  validGrades.sort((a, b) => {
    const bGrade = b.grades[0];
    const aGrade = a.grades[0];
    const bValue = bGrade === 'KG' ? 0 : +bGrade;
    const aValue = aGrade === 'KG' ? 0 : +aGrade;

    if (bValue === aValue) {
      return a.displayName.localeCompare(b.displayName);
    }

    return bValue - aValue;
  });
  otherGrades.sort((a, b) => a.displayName.localeCompare(b.displayName));

  return validGrades.concat(otherGrades);
};
